import QuestionIcon from '../Icon/QuestionIcon.js';
import __vue_component__$3 from './UserRenderer.vue.js';
import __vue_component__$1 from './IssuePriorityRenderer.vue.js';
import __vue_component__ from './IssueStatusRenderer.vue.js';
import __vue_component__$2 from './IssueTypeRenderer.vue.js';

//
var script = {
  name: 'IssueRenderer',
  components: {
    IssueStatusRenderer: __vue_component__,
    IssuePriorityRenderer: __vue_component__$1,
    IssueTypeRenderer: __vue_component__$2,
    User: __vue_component__$3,
    QuestionIcon
  },
  props: {
    issue: {
      type: Object,
      default: undefined
    },
    baseUrl: {
      type: String,
      default: ''
    },
    appearance: {
      type: String,
      default: 'normal',
      validator: value => ['normal', 'compact', 'micro'].includes(value)
    }
  },
  computed: {
    fields() {
      return this.issue.fields || {};
    },

    issueType() {
      return this.fields.issuetype;
    },

    href() {
      return `${this.baseUrl}/browse/${this.issue.key}`;
    },

    status() {
      return this.fields.status;
    },

    isResolved() {
      return !!this.fields.resolution;
    },

    priority() {
      return this.fields.priority;
    },

    assignee() {
      const {
        assignee
      } = this.fields;

      if (!assignee) {
        return undefined;
      }

      return {
        name: assignee.displayName,
        avatar: assignee.avatarUrls && assignee.avatarUrls['48x48'],
        username: assignee.name
      };
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/field-renderers/IssueRenderer.vue_rollup-plugin-vue=script.js